<div [ngClass]="['toast__content', config?.position || '', config?.side || '', config?.noMargin ? 'noMargin' : '']">
   <!-- <p>{{config?.title}}</p>
   <div class="d-flex justify-content-end">
       <button [ngClass]="['btn', 'btn-'+(button?.type || '')]" *ngFor="let button of config?.buttons">{{button?.title}}</button>
   </div> -->
   <ng-content></ng-content>
</div>